import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';
import 'shufflejs';


$(function () {
  //閉じるリンクの設定
  $(document).on('click', '.dismiss', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  function mfp() {
    $('.parent-container').magnificPopup({
      delegate: 'a',
      type: 'image',
      mainClass: 'mfp-fade01',
      removalDelay: 300,
      gallery: {
        enabled: true,
        arrowMarkup: '<span title="%title%" role="button" class="gallery-arrow gallery-arrow-%dir%"></span>',
        tCounter: ''
      },
      callbacks: {
        elementParse: function (item) {
          if (item.el.hasClass('popup-youtube')) {
            item.type = 'iframe';
          }
        },
        open: function () {
          let closeBtn = $('<button class="custom-close-btn"><span></span><span></span></button>');
          this.contentContainer.append(closeBtn);

          closeBtn.on('click', function () {
            $.magnificPopup.close();
          });
        },
        beforeClose: function () {
          // クローズボタンを削除
          $('.custom-close-btn').remove();
        }
      }
      // delegate: 'a',
      // type: 'image',
      // showCloseBtn: true,
      // fixedContentPos: true,
      // preloader: true,
      // // gallery設定を削除
      // removalDelay: 300,
      // mainClass: 'mfp-fade',
      // callbacks: {
      //   beforeOpen: function () {
      //     this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
      //   }
      // }
    });
  }

  //閉じるリンクの設定
  $(document).on('click', '.popup-modal-dismiss', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
  mfp();
  var $btn = $('.p-gallery .category-btn [data-filter], .p-report .category-btn [data-filter]'),
    $list = $('.p-gallery .category-list [data-category], .p-report .category-list [data-category]');

  $btn.on('click', function (e) {
    e.preventDefault();
    $btn.removeClass('active');
    $(this).addClass('active');
    var $btnCat = $(this).attr('data-filter');
    $list.removeClass('is-animate');
    $list.removeClass('parent-container');

    if ($btnCat == 'all') {

      $list.fadeOut().promise().done(function () {
        $list.addClass('is-animate').fadeIn();
        $list.addClass('parent-container').fadeIn();
        mfp();
      });

    } else {

      $list.fadeOut().promise().done(function () {
        $list.filter('[data-category = "' + $btnCat + '"]').addClass('is-animate').fadeIn();
        $list.filter('[data-category = "' + $btnCat + '"]').addClass('parent-container').fadeIn();
        mfp();
      });

    }
  });
});
